var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPushNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_24_icon_container",
    "data-name": "24 icon container",
    width: 24,
    height: 24,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_notification_1864247_000000",
    transform: "translate(-0.516 -0.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5047",
    "data-name": "Path 5047",
    d: "M18.867,18.628v8.82a.756.756,0,0,1-.764.742H5.023a.752.752,0,0,1-.742-.742V14.366a.771.771,0,0,1,.742-.764h8.82a1.189,1.189,0,0,1-.022-.276,4.594,4.594,0,0,1,.234-1.526H5.023A2.533,2.533,0,0,0,2.5,14.345V27.426a2.515,2.515,0,0,0,2.522,2.522H18.1a2.533,2.533,0,0,0,2.544-2.522v-9.01a5.213,5.213,0,0,1-1.526.212.512.512,0,0,1-.255,0Z",
    transform: "translate(0 -7.329)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5048",
    "data-name": "Path 5048",
    d: "M67.816,2.5a3.52,3.52,0,1,0,3.52,3.52A3.524,3.524,0,0,0,67.816,2.5Z",
    transform: "translate(-48.694)",
    fill: "#666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPushNotification);
export default __webpack_public_path__ + "static/media/Icon_Push-notification.b639169f.svg";
export { ForwardRef as ReactComponent };